import { InboxTable, Searchbar } from '@/components'
import { InboxManagementTable } from '@/components/table/management/inbox-management/InboxManagementTable'
import { useInboxManagementContext } from '@/context/InboxContext'
import { SortDirection } from '@/utilities/types'
import { Grid2, styled } from '@mui/material'
import { useCallback, useEffect, useMemo, useState, type FC } from 'react'

const Container = styled('div')({
  width: '100%',
  height: '100%',
  color: '#000',
  background: '#EFF3FD',
})

interface InboxProps {}

const initialFilterState = {
  regularFilters: {},
  dateRanges: {
    createdDate: { start: null, end: null },
    modifiedDate: { start: null, end: null },
  },
  timeRange: { start: null, end: null },
  sort: {
    field: 'id',
    direction: 'asc' as SortDirection,
  },
}

export const Inbox: FC<InboxProps> = () => {
  const [filterState, setFilterState] = useState(initialFilterState)

  const {
    isLoading,
    inboxes,
    optimizedSearchInboxes,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    mutateInboxes,
    totalElem,
    mutateBellNotifications,
    bellNotifications,
  } = useInboxManagementContext()

  console.log('page total ', totalElem)

  const validatedData = useMemo(() => {
    if (!inboxes) return []
    return inboxes
  }, [inboxes])

  console.log('validated data ', validatedData)

  const handleSearchKeyword = (keyword: string) => {
    optimizedSearchInboxes(keyword)
  }

  const handleUpdate = () => {
    console.log('update')
  }

  const handleSort = useCallback((field: string, direction: 'asc' | 'desc') => {
    setFilterState((prevState) => ({
      ...prevState,
      sort: { field, direction },
    }))
  }, [])

  const renderTable = useMemo(() => {
    const baseProps = {
      filterState,
      isLoading: isLoading,
      error: null,
      onSort: handleSort,
    }

    return (
      <InboxManagementTable
        {...baseProps}
        data={validatedData as any}
        handleUpdate={handleUpdate}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalElem={totalElem}
        mutateInboxes={mutateInboxes}
      />
    )
  }, [validatedData, isLoading, totalElem])

  return (
    <Container>
      <Grid2 display={'flex'} alignItems={'center'}>
        <Searchbar handleSearchKeyword={handleSearchKeyword} keyword={''} />
      </Grid2>
      <Grid2
        container
        display={'flex'}
        flexDirection={'column'}
        marginTop={'1%'}
      >
        {renderTable}
      </Grid2>
    </Container>
  )
}
